import React, { Component } from 'react';
import styleable from 'react-styleable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import css from './format-picker.scss';

import { updateReportFormat } from './format-picker-actions';

/**
 * FORMAT PICKER
 * Content in skills quests mastery modal that determines the report format.
 * @param updateReportFormat: Action to manage report formats
 * @param reportFormats: Currently selected report formats array
 */
class FormatPicker extends Component {
    constructor(props) {
        super(props);
        this.i18n = window.i18n;

        this.text = {
            contentTop: this.i18n._(
                'Format Picker - Your report will download in Excel format.'
            ),
            contentBottom: this.i18n._(
                'Format Picker - Please note that large reports may take several minutes to download.'
            ),
            radioGroup: this.i18n._('Format Picker - format-picker'),
            reportFormatHeader: this.i18n._('Format Picker - Report Format *'),
            reportFormatFooter: this.i18n._(
                'Format Picker - * Required Selection'
            )
        };
    }

    render() {
        const { contentTop, contentBottom } = this.text;

        return (
            <div className={css['format-picker']}>
                <p className={css.content}>{contentTop}</p>
                <p className={css.content}>{contentBottom}</p>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    reportFormats: state.formatReport.reportFormats
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ updateReportFormat }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(FormatPicker));



// WEBPACK FOOTER //
// ./components/sub-heading/format-picker/format-picker.js